import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }

  async copy(event) {
    event.preventDefault()
    const btn = event.currentTarget
    const url = btn.dataset.shareUrl || this.urlValue || window.location.href
    const title = btn.dataset.shareTitle || document.title || "Kozenet Pro"

    try {
      if (navigator.share) {
        await navigator.share({
          title: title,
          url: url
        })
      } else {
        await this.copyToClipboard(url)
        this.showCopied(btn)
      }
    } catch (err) {
      console.error("Failed to share/copy", err)

      try {
        await this.copyToClipboard(url)
        this.showCopied(btn)
      } catch (copyError) {
        console.error("Failed to copy fallback", copyError)
      }
    }
  }

  async copyToClipboard(url) {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(url)
      return
    }

    const input = document.createElement("input")
    input.value = url
    input.setAttribute("readonly", "")
    input.className = "sr-only"
    document.body.appendChild(input)
    input.select()
    document.execCommand("copy")
    input.remove()
  }

  showCopied(btn) {
    const originalHtml = btn.innerHTML
    const copiedLabel = btn.dataset.shareCopiedLabel || "Copied"
    btn.innerHTML = `<svg class="h-4 w-4 text-emerald-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path></svg><span class="hidden text-sm text-emerald-500 sm:inline">${copiedLabel}</span>`

    setTimeout(() => {
      btn.innerHTML = originalHtml
    }, 2000)
  }
}
